<template>
  <Dialog :open="open" @update:open="emit('update:open', $event)">
    <DialogScrollContent size="lg">
      <DialogHeader>
        <DialogTitle>
          {{ $t("Select a store") }}
        </DialogTitle>
      </DialogHeader>
      <Combobox
        id="storeSelect"
        v-model="selected"
        :options="stores.map((store) => ({ value: store.id, label: store.name }))"
        :fullwidth="true"
      />
      <DialogFooter>
        <button
          type="button"
          class="btn btn-primary"
          @click.prevent="emit('select', selected)"
        >
          {{ $t("Validate store") }}
        </button>
      </DialogFooter>
    </DialogScrollContent>
  </Dialog>
</template>

<script setup>
import { ref } from "vue";
import Combobox from "@/components/ui/Combobox.vue";
import { Dialog, DialogScrollContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";

defineProps({
  open: {
    type: Boolean,
    default: false
  },
  stores: {
    type: Array,
    default: () => []
  }
});

const emit = defineEmits(["update:open", "select"]);

const selected = ref(null);
</script>
